import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import {
  APPLY_REGISTER_CLASS_ID,
  APPLY_REGISTER_ID,
} from '@/modules/common/constants/search-params.ts';
import { queryClient } from '@/modules/common/query.ts';
import { itemsLockFunctional } from '@/modules/entity/components/common/CompletionInformation.tsx';
import { entityPaths } from '@/modules/entity/routes.tsx';
import { SHOW_MODAL_COMPLETE_KYC } from '@/modules/investor-dashboard/queries/entity.ts';
import { BaseModalProps, Button, ModalContentWrapper } from 'ui';
import { LockGrayIcon } from 'ui/icons';

interface CompleteKYCModalProps extends BaseModalProps {
  entityId: number;
}

export const CompleteKYCModal = ({ open, onClose, entityId }: CompleteKYCModalProps) => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const apply_register_id = params.get(APPLY_REGISTER_ID);
  const apply_register_class_id = params.get(APPLY_REGISTER_CLASS_ID);

  const handleGoToConfirmKYC = () => {
    navigate(
      {
        pathname: entityPaths.dynamic.updateEntity(String(entityId)),
        search: createSearchParams({
          [APPLY_REGISTER_ID]: String(apply_register_id ?? ''),
          [APPLY_REGISTER_CLASS_ID]: String(apply_register_class_id ?? ''),
        }).toString(),
      },
      {
        replace: false,
      },
    );
  };

  const handleClose = () => {
    queryClient.setQueryData<boolean>([SHOW_MODAL_COMPLETE_KYC], true);
    onClose();
  };

  return (
    <ModalContentWrapper
      title="Complete KYC to unlock functionality"
      open={open}
      onClose={handleClose}
    >
      <div className="mb-4">You currently have the following limitations:</div>
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-4 w-full">
          {itemsLockFunctional.map(item => (
            <div className="flex gap-3" key={item.name}>
              <span className="relative flex items-center justify-center">
                <span className="p-4 rounded-full bg-gray-200">
                  <img
                    src={item.icon}
                    alt="Subscription Icon"
                    className="w-6 h-6 min-w-6 min-h-6"
                  />
                </span>
                <span className="absolute bottom-[-2px] right-[-2px]">
                  <img src={LockGrayIcon} alt="lock" className="w-6 h-6 min-w-6 min-h-6" />
                </span>
              </span>
              <span className="flex flex-col items-start gap-1 text-left">
                <span className="text-[16px] leading-6 text-gray-900">{item.name}</span>
                <span className="text-sm leading-[22px] text-[#6B6B6B]">{item.description}</span>
              </span>
            </div>
          ))}
        </div>
        <div className="flex flex-col gap-4">
          <Button onClick={handleGoToConfirmKYC} variant="primary">
            Verify now
          </Button>

          <Button onClick={handleClose} variant="secondary">
            Verify later
          </Button>
        </div>
      </div>
    </ModalContentWrapper>
  );
};
